import RestClient from './RestClient';
import { Shift, User } from '../../models';

class Shifts extends RestClient {
    constructor() {
        super({
            "model": Shift,
            "entryPoint": "shift",
            "resource": "shift",
            "resources": "shifts",
            "id": "id"
        });
    }

    loadSuggestion(user_id) {
        return this.GET('/shift/suggestion', { user_id })
            .then(response => response.json())
            .then(json => {
                if (json.suggestion)
                    return {
                        ...json,
                        suggestion: new User(json.suggestion)
                    };
                throw new Error(json.flash.error);
            });
    }
}

const ShiftsApi = new Shifts();

export default ShiftsApi;
